import { RequestBaseFields, RequestType } from "../types/request.types";

const { fetchUrl, rootPath } = MtsAppVars;

export const mtsUrl = (path: string) => `${fetchUrl}${rootPath}${path}`;

export const requestsPath = (reqType: RequestType) =>
  reqType.split('_').slice(0, -1).join('_') + 's';

export const requestPath = (reqType: RequestType, reqId: number | string) =>
  `${requestsPath(reqType)}/${reqId}`;

export const requestUrl = (r: RequestBaseFields) =>
  mtsUrl(`${r.request_type}s/${r.id}`);

export const requestResourceUrl = (r: RequestBaseFields, resourceType: string) =>
  mtsUrl(`${requestPath(r.request_type, r.id)}/${resourceType}`);